import { createSpotifyForArtistsBrowserIdentifierMapping } from '@spotify-internal/event-definitions/es5/events/createSpotifyForArtistsBrowserIdentifierMapping';
import { createSpotifyForArtistsBrowserIdentifierMappingNonAuth } from '@spotify-internal/event-definitions/es5/events/createSpotifyForArtistsBrowserIdentifierMappingNonAuth';
import { getCorrelationId } from './getCorrelationId';
import { eventSender } from '../Tracking/gabito';
import { transport } from '../../../features/src/transport';

const SESSION_KEY_AUTH = 'S4A_BROWSER_ID_MAPPING_SENT_AUTH';
const SESSION_KEY_NON_AUTH = 'S4A_BROWSER_ID_MAPPING_SENT_NON_AUTH';

function getSpT(): string | null {
  return document.cookie.match(/sp_t=([^;]+)/)?.[1] ?? null;
}

export function emitBrowserIdentifierMapping() {
  if (typeof window === 'undefined') return;

  const authenticated = transport.isAuthenticated();
  const sessionKey = authenticated ? SESSION_KEY_AUTH : SESSION_KEY_NON_AUTH;
  if (sessionStorage.getItem(sessionKey)) return;

  const spT = getSpT();
  const correlationId = getCorrelationId();
  if (!spT || !correlationId) return;

  const data = {
    legacy_correlation_id: correlationId,
    sp_t: spT,
    web_surface: 'marketing',
  };

  eventSender.send(
    authenticated
      ? createSpotifyForArtistsBrowserIdentifierMapping(data)
      : createSpotifyForArtistsBrowserIdentifierMappingNonAuth(data),
    { authorize: authenticated },
  );

  sessionStorage.setItem(sessionKey, '1');
}
